module.exports = __webpack_public_path__ + "static/media/app-store.be397e42.svg";